export default "__VITE_ASSET__DlKi5ce$__"